var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { STORAGE_NAME } from './constants';
import { useStorage, createAction } from 'master-hook';
import { STORAGE_NAME as authStorageName } from '../use-auth';
var errorId = 0;
var messageId = 0;
export var registerError = createAction(function (_a, addToStack) {
    var title = _a.title, text = _a.text, more = _a.more, _b = _a.code, code = _b === void 0 ? 2500 : _b, _c = _a.source, source = _c === void 0 ? 'undefined' : _c;
    if (addToStack === void 0) { addToStack = true; }
    var _d = useStorage(STORAGE_NAME), errors = _d.errors, setErrors = _d.setErrors;
    var newErrors = __spreadArray([], errors, true);
    var error = { id: errorId++, title: title, text: text, code: code, source: source };
    newErrors.push(error);
    console.error("\n\u041E\u0448\u0438\u0431\u043A\u0430 ".concat(code, ": ").concat(title, "\n\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A: '").concat(source, "'\n\n").concat(text, "\n\nMore info:\n").concat(typeof (more) === 'object' ? JSON.stringify(more) : more));
    // Не показываем ошибку, если это ошибки клиента (4xx)
    var has4xxError = code && code.toString().length === 3 && code.toString()[0] === '4';
    if (addToStack && !has4xxError) {
        setErrors(newErrors);
    }
    return error;
});
export var dismissError = createAction(function (id) {
    var _a = useStorage(STORAGE_NAME), errors = _a.errors, setErrors = _a.setErrors;
    var newErrors = errors.filter(function (item) { return item.id !== id; });
    setErrors(newErrors);
});
// Следим за тем, что люди делают в приложении
// TODO. Нужно сделать периодическую отвправку на сервер
export var registerActivity = createAction(function (path) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    var setLastActivity = useStorage(STORAGE_NAME).setLastActivity;
    var timestamt = new Date();
    setLastActivity(timestamt);
});
// Дергаем колбэк, если пользователь неактивен дольше необходимого времени
export var trackUnactive = createAction(function track(duration, callback) {
    var then = useStorage(STORAGE_NAME).lastActivity;
    setTimeout(function () {
        var last = useStorage(STORAGE_NAME).lastActivity;
        if (last === then) {
            callback();
        }
        else {
            var newDuration = duration - (new Date().getTime() - new Date(last).getTime());
            track(newDuration, callback);
        }
    }, duration);
});
export var purge = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
    var resetApp, _a, resetAuth, setIsInitialized;
    return __generator(this, function (_b) {
        resetApp = useStorage(STORAGE_NAME).reset;
        _a = useStorage(authStorageName), resetAuth = _a.reset, setIsInitialized = _a.setIsInitialized;
        resetApp();
        resetAuth();
        setIsInitialized(true);
        return [2 /*return*/];
    });
}); }, { setIsPendingTo: [STORAGE_NAME, authStorageName] });
